export default __webpack_public_path__ + "static/media/uk-car-emissions.70e9d608.webp";